const Prueba = () => {
  return "aca dentro podes poner el codigo react";
};

export default Prueba;
